import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollIntoView]'
})
export class ScrollIntoViewDirective {

  @Input() set appScrollIntoView(condition: boolean) {
    if (condition) {
      console.log("El ", this.el)
      this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  constructor(private el: ElementRef) { }
}
